import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer.js'
import Slider from "react-slick"
import ProductTabs from '../../components/ProductTabs'
import SEO from '../../components/SEO/SEO';
import { seoData } from '../../utils/seoData';

const DiNitroDiPhenylSulphonePage = () => {

    const productData = {
        description: [
            "3,3'-Dinitrodiphenyl Sulfone (DNDPS) is a specialized organic compound used primarily as an intermediate in the synthesis of high-performance polymers, dyes, and pharmaceutical compounds. This yellow crystalline powder is valued for its thermal stability and chemical reactivity in advanced material applications.",
            "Supplied in high purity with consistent quality for demanding industrial and research applications.",
            "• Bags: typically 25 kg fiber drums or multi-wall paper bags with polyethylene liner — standard for fine chemical handling.",
            "• Drums: 50 kg or 100 kg fiber drums with moisture-resistant sealing for larger quantities.",
            "• Custom packaging: available for specialized requirements including smaller laboratory quantities or bulk industrial orders.",
            "• Storage requirements: store in cool, dry conditions away from direct sunlight and incompatible materials.",
            "• Packing & labeling: all packages supplied with Certificate of Analysis (CoA), Safety Data Sheets (SDS), and proper hazard labeling. Packaging ensures product stability and prevents contamination during storage and transport."
        ],
        applications: [
            {
                id: 1,
                title: "High-Performance Polymer Synthesis",
                description: "3,3'-Dinitrodiphenyl Sulfone is a key intermediate in producing high-performance polymers such as polysulfones and polyethersulfones (PES). These materials are used in aerospace, automotive, and electronics industries for their exceptional thermal stability and mechanical properties.",
                image: "/images/products/dinitro-diphenyl-sulphone/high.jpg"
            },
            {
                id: 2,
                title: "Pharmaceutical Intermediates",
                description: "Used in the synthesis of pharmaceutical compounds and active pharmaceutical ingredients (APIs). DNDPS serves as a building block for various drug molecules requiring specific structural features and functional groups.",
                image: "/images/products/dinitro-diphenyl-sulphone/pharma.jpg"
            },
            {
                id: 3,
                title: "Dye & Pigment Manufacturing",
                description: "Applied in the production of specialty dyes and pigments for textiles, printing, and industrial coatings. The compound's chemical structure allows for the creation of colorants with specific properties and color fastness characteristics.",
                image: "/images/products/dinitro-diphenyl-sulphone/dye.jpg"
            },
            {
                id: 4,
                title: "Specialty Chemical Synthesis",
                description: "Essential intermediate in organic synthesis for producing specialty chemicals, advanced materials, and research compounds. Used in developing new materials with tailored properties for electronics, coatings, and high-tech applications.",
                image: "/images/products/dinitro-diphenyl-sulphone/special.jpg"
            }
        ]
    };

    return (
        <Fragment>
            <SEO title={seoData.dinitroDiphenylSulphone.title} description={seoData.dinitroDiphenylSulphone.description} keywords={seoData.dinitroDiphenylSulphone.keywords} />
            <Navbar/>
            <PageTitle pageTitle="3,3 DI Nitro Di Phenyl Sulphone" pagesub="3,3 DI Nitro Di Phenyl Sulphone" parentPage="Products" parentLink="#" />
            <div className="team-pg-area product-page-section">
                <div className="container">
                    <div className="team-info-wrap">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="team-info-img">
                                    <Slider dots={true} arrows={true} infinite={true} speed={500} slidesToShow={1} slidesToScroll={1} autoplay={true} autoplaySpeed={3000}>
                                        <div className="image-box">
                                            <img src='/images/products/dinitro-diphenyl-sulphone/1.jpg' alt="3,3 DI Nitro Di Phenyl Sulphone" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/dinitro-diphenyl-sulphone/2.jpg' alt="DNDPS Powder" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/dinitro-diphenyl-sulphone/3.jpg' alt="DNDPS Packaging" />
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="team-info-text">
                                    <h2>3,3'-Dinitrodiphenyl Sulfone</h2>
                                    <ul>
                                        <li>Chemical Formula: <span>C₁₂H₈N₂O₆S</span></li>
                                        <li>Purity: <span>98%+</span></li>
                                        <li>Appearance: <span>Yellow Crystalline Powder</span></li>
                                        <li>Packaging: <span>25kg, 50kg Drums/Bags</span></li>
                                        <li>CAS Number: <span>1656-27-1</span></li>
                                        <li>Molecular Weight: <span>308.26 g/mol</span></li>
                                        <li>Grade: <span>Industrial/Research</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ProductTabs product={productData} />
                </div>
            </div>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};

export default DiNitroDiPhenylSulphonePage;
